/*
|--------------------------------------------------------------------------
| Alert Bar
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.alertBar = {
	"init": function(){
		var $alertContainer	= $("#content .alert");
		if (!$alertContainer.length) {return;}
		
		__gh__webApp.schoolClosings.showAlert(function(){
			__gh__webApp.weather.accuweather.showAlert(function(){
				__gh__webApp.alertBar.removeAlertBar();
			});
		});	
	},
	
	"removeAlertBar": function(){
		var $alertContainer		= $("#content .alert");
			hasAlerts 			= ($alertContainer.html().length > 0);
		if (hasAlerts) {return;}
		$alertContainer.remove();
	}
};